<div class="question-container" [formGroup]="group" [ngClass]="{active: isSelected, interviewQuestion: interviewMode}">
  <div [ngClass]="isConfigInvalid()?'invalid-question':''">
    <div class="question-header" *ngIf="!interviewMode" (click)="selectQuestion()">
      <button type="button" class="btn btn-link float-start" (click)="expanded = !expanded">
        <i aria-hidden="true" class="fa" [ngClass]="{'fa-angle-right': !expanded, 'fa-angle-down': expanded}"></i>
      </button>
      <span class="question-mapkey">
        {{config.mapKeyName}}
      </span>
      <span class="question-mapkey float-end pe-2">
        {{config.answerTypeName}}
      </span>
    </div>
    <div class="question-body" *ngIf="expanded && !useCondensedView">

      <div class="question-text rendered-quill-content ql-editor-updated" [innerHTML]="questionText"></div>
      <div class="help-text rendered-quill-content ql-editor-updated" [innerHTML]="helpText"
        *ngIf="config.helpText?.length"></div>
      <div class="question-form">
        <mat-form-field class="w-100 mb-1">
          <input [attr.data-test-input-type]="inputType" matInput [placeholder]="config?.Placeholder"
            [formControlName]="config.id" [maskValue]="maskConfig" (focus)="onFocus()" (blur)="onBlur()"
            (keydown)="filterInput($event)" [readonly]="services.interviewService.isReadOnly">

          <mat-error *ngIf="group.get(config.id)?.hasError('required')">required</mat-error>
          <mat-error *ngIf="group.get(config.id)?.hasError('minlength')">Minimum length is
            {{config?.MinLength}}</mat-error>
          <mat-error *ngIf="group.get(config.id)?.hasError('maxlength')">Maximum length is
            {{config?.MaxLength}}</mat-error>
          <mat-error
            *ngIf="group.get(config.id)?.hasError('validationError')">{{group.get(config.id)?.errors.validationError}}</mat-error>
        </mat-form-field>
      </div>
    </div>
    <div *ngIf="expanded && useCondensedView" class="condensed-view" [ngClass]="config.helpText?.length ? 'condensed-hint-view' : 'no-hint'">
      <mat-form-field class="w-100" appearance="fill">
        <mat-label [innerHTML]="questionText" class="condensed-label-view"></mat-label>
        <input [attr.data-test-input-type]="inputType" matInput [placeholder]="config?.Placeholder"
          [formControlName]="config.id" [maskValue]="maskConfig" (focus)="onFocus()" (blur)="onBlur()"
          (keydown)="filterInput($event)" [readonly]="services.interviewService.isReadOnly">
        <mat-hint [innerHTML]="helpText"></mat-hint>
        <mat-error *ngIf="group.get(config.id)?.hasError('required')">required</mat-error>
        <mat-error *ngIf="group.get(config.id)?.hasError('minlength')">Minimum length is
          {{config?.MinLength}}</mat-error>
        <mat-error *ngIf="group.get(config.id)?.hasError('maxlength')">Maximum length is
          {{config?.MaxLength}}</mat-error>
        <mat-error
          *ngIf="group.get(config.id)?.hasError('validationError')">{{group.get(config.id)?.errors.validationError}}</mat-error>
      </mat-form-field>
    </div>
    <interview-processing-status variant="question" [questionId]="config.id"></interview-processing-status>
  </div>
</div>